var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-173.08 152.31-427.694l37.307-28.153L480-230.617l290.383-225.23 37.307 28.153L480-173.08Zm0-140.845L152.31-568.539 480-823.152l327.69 254.613L480-313.925Zm0-269.844Zm0 212.306 253.538-197.076L480-765.231 226.462-568.539 480-371.463Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignElements);
export default __webpack_public_path__ + "static/media/design-elements.18d59a8dd2049a2d1152f8242e8db50c.svg";
export { ForwardRef as ReactComponent };